import { SagaIterator, Saga } from 'redux-saga';
import { all, put, call, select, takeLatest } from 'redux-saga/effects';
import _ from 'lodash';
import { MCAFirebaseSaga } from '../root-saga';
import {
  FirestoreSnapshot,
  MealProps,
  PlaceOrderAction,
  GET_MEALS,
  PLACE_ORDER,
  MealCookProps,
  AddMealAction,
  EditMealAction,
  ADD_MEAL,
  EDIT_MEAL,
  GET_MYMEALS,
  SetMealVisibilityAction,
  SET_MEAL_VISIBILITY,
  DeleteMealAction,
  DELETE_MEAL,
  GET_MORE_MEALS,
} from './types';
import { setLoading, setError } from '../app-globals/actions';
import { setMeals, getMyMeals, setLastMealField } from './actions';
import { getUserState } from '../user/selector';
import { firestore } from '../../constants/firebase';
import { sendNotification } from '../notifications/actions';
import { getMealState } from './selector';

function* getMoreMeals(): SagaIterator<void> {
  try {
    const { lastMealField, meals } = yield select(getMealState);
    const { user } = yield select(getUserState);
    if (user.accountType === 'i offer') {
      return;
    }
    // console.log(JSON.parse(temp));
    yield put(setLoading(true, 'Fetching more meals'));
    const next = firestore
      .collection('meals')
      .where('visible', '==', true)
      .startAfter(lastMealField)
      .limit(10);

    const userRef = firestore.collection('users');

    const snapshot = yield call(MCAFirebaseSaga.firestore.getCollection, next);

    const userCollection = yield call(
      MCAFirebaseSaga.firestore.getCollection,
      userRef
    );

    const meal: MealProps[] = [];
    let lastField: any;
    snapshot.forEach((item: FirestoreSnapshot) => {
      const cookDetails: MealCookProps = {
        id: '',
        address: {
          city: '',
          street: '',
          note: '',
        },
        firstName: '',
        image: '',
        type: '',
        location: {
          lat: 0,
          lng: 0,
        },
        description: '',
      };
      userCollection.forEach((user: FirestoreSnapshot) => {
        const data = user.data();
        if (data.userid === item.data().cook) {
          cookDetails.id = data.userid;
          cookDetails.firstName = data.firstName;
          cookDetails.image = data.image;
          cookDetails.type = data.accountType;
          cookDetails.address = data.address;
          cookDetails.location = data.location;
          cookDetails.description = data.description;
        }
      });

      const body = {
        id: item.id,
        ...item.data(),
        cookDetails,
      };
      lastField = snapshot.docs[snapshot.docs.length - 1];
      meal.push(body);
    });
    const newmeals = meals.concat(meal);
    yield put(setLastMealField(lastField));
    yield put(setMeals(newmeals));
    yield put(setLoading(false, ''));
  } catch (error) {
    yield put(setLoading(false, ''));
    console.log(error);
  }
}

function* fetchMeals(): SagaIterator<void> {
  try {
    const { user } = yield select(getUserState);
    if (user.accountType === 'i offer') {
      return;
    }
    yield put(setLoading(true, 'Fetching Meals'));
    const mealRef = firestore
      .collection('meals')
      .where('visible', '==', true)
      // .limit(10);

    const userRef = firestore.collection('users');

    const snapshot = yield call(
      MCAFirebaseSaga.firestore.getCollection,
      mealRef
    );

    const userCollection = yield call(
      MCAFirebaseSaga.firestore.getCollection,
      userRef
    );

    const meal: MealProps[] = [];
    let lastMealField: any;
    snapshot.forEach((item: FirestoreSnapshot) => {
      const cookDetails: MealCookProps = {
        id: '',
        address: {
          city: '',
          street: '',
          note: '',
        },
        firstName: '',
        image: '',
        type: '',
        location: {
          lat: 0,
          lng: 0,
        },
        description: '',
      };
      userCollection.forEach((user: FirestoreSnapshot) => {
        const data = user.data();
        if (data.userid === item.data().cook) {
          cookDetails.id = data.userid;
          cookDetails.firstName = data.firstName;
          cookDetails.image = data.image;
          cookDetails.type = data.accountType;
          cookDetails.address = data.address;
          cookDetails.location = data.location;
          cookDetails.description = data.description;
        }
      });

      const body = {
        id: item.id,
        ...item.data(),
        cookDetails,
      };
      lastMealField = snapshot.docs[snapshot.docs.length - 1];
      meal.push(body);
    });
    yield put(setMeals(meal));
    yield put(setLastMealField(lastMealField));
    yield put(setLoading(false, ''));
  } catch (e) {
    yield put(setLoading(false, ''));
  }
}

function* fetchMyMeals(): SagaIterator<void> {
  try {
    const { user } = yield select(getUserState);
    yield put(setLoading(true, 'Fetching Meals'));

    const mealRef = firestore
      .collection('meals')
      .where('cook', '==', user.userid);

    const snapshot = yield call(
      MCAFirebaseSaga.firestore.getCollection,
      mealRef
    );
    const meal: MealProps[] = [];
    snapshot.forEach((item: FirestoreSnapshot) => {
      const body = {
        id: item.id,
        ...item.data(),
      };
      meal.push(body);
    });
    yield put(setMeals(_.orderBy(meal, ['timeadded'], 'desc')));
    yield put(setLoading(false, ''));
  } catch (e) {
    yield put(setLoading(false, ''));
  }
}

function* addMeal({ meal }: AddMealAction): SagaIterator<void> {
  try {
    yield put(setLoading(true, 'Adding Offer'));
    const { user } = yield select(getUserState);
    const generateImgName = Math.random()
      .toString(36)
      .substring(2);
    const imageFilename = 'MEALS_' + generateImgName.toUpperCase() + Date.now();

    const task = yield call(
      MCAFirebaseSaga.storage.uploadString,
      imageFilename,
      meal.image,
      'data_url',
      { contentType: 'image/jpeg' }
    );

    yield task; // Wait for upload to complete

    const imageUrl = yield call(
      MCAFirebaseSaga.storage.getDownloadURL,
      imageFilename
    );
    delete meal.image;
    const body = {
      image: imageUrl,
      ...meal,
      cook: user.userid,
      timeadded: new Date(),
      visible: true,
    };

    const addMeal = yield call(
      MCAFirebaseSaga.firestore.addDocument,
      'meals',
      body
    );
    console.log(addMeal);
    yield put(setLoading(false, 'Offer Added Successfully'));
  } catch (e) {
    yield put(setLoading(false, ''));
    yield put(setError(true, e.message));
  }
}

function* EditMeal({ meal }: EditMealAction): SagaIterator<void> {
  try {
    yield put(setLoading(true, 'Editing Offer'));
    const { user } = yield select(getUserState);
    if (meal.image !== '') {
      const generateImgName = Math.random()
        .toString(36)
        .substring(2);
      const imageFilename =
        'MEALS_' + generateImgName.toUpperCase() + Date.now();

      const task = yield call(
        MCAFirebaseSaga.storage.uploadString,
        imageFilename,
        meal.image,
        'data_url',
        { contentType: 'image/jpeg' }
      );

      yield task; // Wait for upload to complete

      const imageUrl = yield call(
        MCAFirebaseSaga.storage.getDownloadURL,
        imageFilename
      );
      delete meal.image;
      const body = {
        image: imageUrl,
        ...meal,
        cook: user.userid,
        timeadded: new Date(),
        visible: true,
      };
      yield call(
        MCAFirebaseSaga.firestore.setDocument,
        `meals/${meal.id}`,
        body,
        {
          merge: true,
        }
      );
    } else {
      delete meal.image;
      const body = {
        ...meal,
        cook: user.userid,
        timeadded: new Date(),
        visible: true,
      };

      yield call(
        MCAFirebaseSaga.firestore.setDocument,
        `meals/${meal.id}`,
        body,
        {
          merge: true,
        }
      );
    }

    yield put(setLoading(false, 'Offer Edited Successfully'));
    window.location.replace('/mymeals');
  } catch (e) {
    yield put(setLoading(false, ''));
    yield put(setError(true, e.message));
  }
}

function* mealVisibility({
  meal,
}: SetMealVisibilityAction): SagaIterator<void> {
  try {
    yield put(setLoading(true, 'Updating Offer'));
    yield call(
      MCAFirebaseSaga.firestore.updateDocument,
      `meals/${meal.mealid}`,
      'visible',
      meal.visible
    );
    yield put(getMyMeals());
    yield put(setLoading(false, ''));
  } catch (e) {
    yield put(setLoading(false, e));
  }
}

function* deleteMeal({ meal }: DeleteMealAction): SagaIterator<void> {
  try {
    yield put(setLoading(true, 'Deleting Offer'));
    const { user } = yield select(getUserState);
    yield call(
      MCAFirebaseSaga.firestore.deleteDocument,
      `meals/${meal.mealid}`
    );
    if (user.accountType === 'admin') {
      const send = {
        action: 'deleted',
        reason: meal.reason,
        order: meal.mealid,
        mealname: meal.mealname,
      };
      yield put(sendNotification(send, meal.cookid));
    }

    yield put(setLoading(false, ''));
  } catch (e) {
    yield put(setLoading(false, e));
  }
}

function* placeOrder({ order }: PlaceOrderAction): SagaIterator<void> {
  try {
    yield put(setLoading(true, 'Sending Order'));
    const { user } = yield select(getUserState);
    const updatebody = {
      portions: order.quantity,
    };
    const updatemeal = yield call(
      MCAFirebaseSaga.firestore.setDocument,
      `meals/${order.mealid}`,
      updatebody,
      {
        merge: true,
      }
    );
    yield updatemeal;
    delete order.quantity;
    const body = {
      ...order,
      guest: user.userid,
      status: 'waiting',
      timeadded: new Date(),
    };
    const placeOrder = yield call(
      MCAFirebaseSaga.firestore.addDocument,
      'orders',
      body
    );
    yield placeOrder;
    const send = {
      action: 'placed',
      reason: '',
      mealname: '',
      order: placeOrder.id,
    };

    yield put(sendNotification(send, order.cook));
    yield put(setLoading(false, ''));
  } catch (e) {
    yield put(setError(true, e));
    yield put(setLoading(false, ''));
  }
}

export function* MealSaga() {
  yield all([
    takeLatest(GET_MEALS, fetchMeals),
    takeLatest(GET_MYMEALS, fetchMyMeals),
    takeLatest(ADD_MEAL, addMeal),
    takeLatest(EDIT_MEAL, EditMeal),
    takeLatest(DELETE_MEAL, deleteMeal),
    takeLatest(SET_MEAL_VISIBILITY, mealVisibility),
    takeLatest(PLACE_ORDER, placeOrder),
    takeLatest(GET_MORE_MEALS, getMoreMeals),
  ]);
}
